import React, {Component} from 'react';
import '../../../../styles/Home.css'
import '../../../../styles/Miesieczne.css'
import * as acc from "accounting";
import BiletyJednorazoweService from "./BiletyJednorazoweService";
import KoszykService from "../../../../koszyk/KoszykService";
import QRCode from "qrcode.react";
import {Button} from "react-bootstrap";
import {Link} from "react-router-dom";
import AppConfig from "../../../../AppConfig";
import BiletyJednorazoweZglos from "./BiletyJednorazoweZglos";
import ReactTooltip from "react-tooltip";
import Select from 'react-select'
import {confirmAlert} from "react-confirm-alert";
import Panel from "../../Panel";
import {NotificationManager} from "react-notifications";
import BiletyJednorazoweFaktura from "./BiletyJednorazoweFaktura";
import moment from "moment";


export default class BiletyJednorazowe extends Component {

    constructor(props) {
        super(props);

        this.state = {
            data: [],
            filtr: {label: 'WSZYSTKIE', value: ''},
            size: 10,
            page: 0,
            totalPages: 2,
            loading: true,
            idBi: ''
        };

        this.onChangeStatusFiltr = this.onChangeStatusFiltr.bind(this)
    }

    componentWillMount() {
        window.scrollTo(0, 0)
        this.getBilety(10, 0, '')
    }

    getBilety(size, page, filter) {
        BiletyJednorazoweService.getBilety(JSON.parse(sessionStorage.getItem('loggedIn')).idKl, size, page, "&statPoz=" + filter)
            .then(function (response) {
                this.setState({
                    data: response.data.content,
                    totalPages: response.data.totalPages - 1,
                    size: size,
                    page: page,
                    loading: false
                })
            }.bind(this)).catch(err => {
            console.log(err);
        });
    }

    onChangeStatusFiltr(e) {
        this.setState({filtr: e, loading: true});
        this.filtrujBilety(e.value)
    }

    filtrujBilety(status) {
        this.getBilety(10, 0, status)
    }

    nextPage() {
        this.setState({loading: true})
        this.getBilety(this.state.size, this.state.page + 1, this.state.filtr.value)
    }

    previousPage() {
        this.setState({loading: true})
        this.getBilety(this.state.size, this.state.page - 1, this.state.filtr.value)
    }

    checkStatus(status) {
        if (status === -1) {
            return <span style={{
                fontWeight: 'bold',
                background: '#dc3545',
                color: 'white',
                borderRadius: 5,
                padding: '4px 8px'
            }}>DO&nbsp;OPŁACENIA</span>
        } else {
            if (status === 0) {
                return <span style={{
                    fontWeight: 'bold',
                    background: '#17a2b8',
                    color: 'white',
                    borderRadius: 5,
                    padding: '4px 8px'
                }}>REZERWACJA</span>
            } else {
                if (status === 1) {
                    return <span style={{
                        fontWeight: 'bold',
                        background: '#57b13c',
                        color: 'white',
                        borderRadius: 5,
                        padding: '4px 8px'
                    }}>OPŁACONY</span>
                } else {
                    if (status === 2) {
                        return <span style={{
                            fontWeight: 'bold',
                            background: '#ffa707',
                            color: 'white',
                            borderRadius: 5,
                            padding: '4px 8px'
                        }}>SKASOWANY</span>
                    } else {
                        if (status === -2 || status === -3) {
                            return <span style={{
                                fontWeight: 'bold',
                                background: '#dc3545',
                                color: 'white',
                                borderRadius: 5,
                                padding: '4px 8px'
                            }}>ANULOWANO</span>
                        } else {
                            if (status === -4) {
                                return <span style={{
                                    fontWeight: 'bold',
                                    background: '#929292',
                                    color: 'white',
                                    borderRadius: 5,
                                    padding: '4px 8px'
                                }}>ZWRÓCONO</span>
                            } else {
                                if (status === -5) {
                                    return <span style={{
                                        fontWeight: 'bold',
                                        background: '#929292',
                                        color: 'white',
                                        borderRadius: 5,
                                        padding: '4px 8px'
                                    }}>NIEOPŁACONY</span>
                                } else {
                                    if (status === -6) {
                                        return <span style={{
                                            fontWeight: 'bold',
                                            background: '#929292',
                                            color: 'white',
                                            borderRadius: 5,
                                            padding: '4px 8px'
                                        }}>PŁAT.ZWR.</span>
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    checkWazny(item) {
        if (item.waznyDo === item.waznyOd) {
            return <div><i className="fa fa-calendar"></i> {item.waznyDo} <i className="fa fa-clock-o"></i>{item.godz}
            </div>
        } else {
            return item.waznyOd + ' - ' + item.waznyDo + ' ' + item.godz
        }
    }

    anulujBilet(item) {
        KoszykService.putAnulujTransakcje(item.idBi, item.platnosciTransakcja).then(function (response) {
            this.componentWillMount();
            NotificationManager.warning("", "Bilet został anulowany ", 5000)
        }.bind(this)).catch(err => {
            console.log(err);
        });
    }

    submit(item) {
        confirmAlert({
            title: 'Anulowanie biletu',
            message: 'Czy na pewno chcesz anulować bilet?',
            buttons: [
                {
                    label: 'Tak',
                    onClick: () => this.anulujBilet(item)
                },
                {
                    label: 'Nie',
                    onClick: () => console.log('Anulowano anulowanie biletu.')
                }
            ]
        });
    };

    render() {

        if (this.props.zglos) {
            return <Panel><BiletyJednorazoweZglos idBi={this.props.match.params.idBi}
                                                  idKu={this.props.match.params.idKu}/></Panel>
        } else {
            if (this.props.faktura) {
                return <Panel><BiletyJednorazoweFaktura idBi={this.props.match.params.idBi}/></Panel>
            } else {
                return <Panel>
                    <div className="container miesieczne">

                        <h4 style={{textAlign: 'center', marginBottom: 20}}><b>Bilety jednorazowe</b></h4>
                        <div className="row" style={{marginTop: 15, marginBottom: 15}}>
                            <div className="col-6 text-right" style={{lineHeight: '34px'}}>Wyświetl bilety o statusie:
                            </div>
                            <div className="col-6"><Select style={{height: 40}} value={this.state.filtr}
                                                           onChange={this.onChangeStatusFiltr}
                                                           clearable={false}
                                                           options={[
                                                               {label: 'WSZYSTKIE', value: ''},
                                                               {label: 'OPŁACONY', value: 1},
                                                               {label: 'REZERWACJA', value: 0},
                                                               {label: 'DO OPŁACENIA', value: -1},
                                                               {label: 'ANULOWANO', value: -2},
                                                               {label: 'SKASOWANY', value: 2},
                                                               {label: 'ZWRÓCONO', value: -4},
                                                               {label: 'NIEOPŁACONY', value: -5},
                                                               {label: 'PŁATNOŚĆ ZWRÓCONA', value: -6},
                                                           ]}
                                                           matchPos="start"/></div>
                        </div>
                        <hr/>
                        {this.state.loading ? <div style={{paddingTop: 10, textAlign: 'center', color: '#58b13d'}}>
                                <div className="loaderDim"><i className="fa fa-spinner fa-pulse fa-2x fa-fw"> </i></div>
                            </div> :
                            <div>
                                {this.state.data.length === 0 ?
                                    <h5 className="text-center" style={{paddingTop: 50}}>Brak biletów</h5> :
                                    <div>
                                        <div>
                                            <p style={{
                                                marginBottom: 0,
                                                color: '#dc3545',
                                                fontSize: '0.875rem',
                                                textAlign: 'center',
                                                fontWeight: 'bold'
                                            }}>UWAGA! Bilet można anulować do 30 minut przed startem kursu.</p>
                                            <p style={{color: '#dc3545', fontSize: '0.875rem', textAlign: 'center'}}>Od
                                                zwracanych Pasażerowi przez Przewoźnika należności zgodnie z art. 17
                                                ust. 4 Ustawy prawo przewozowe, Przewoźnik potrąca 20% odstępnego.
                                                Minimalna opłata przy zwrocie wynosi 1,10 zł.</p>
                                        </div>

                                        {this.state.data.map((item, index) => {
                                            return (
                                                <div>
                                                    <div
                                                        className={"wynik"}>
                                                        <div key={"kurs" + item.idKu} id={"bilet" + item.idBi}
                                                             style={{marginLeft: 5, marginRight: 5}}
                                                             className={"row"}>
                                                            <div className="col-sm-2 text-center">
                                                                <QRCode value={item.idBi.toString()} size={110}/>
                                                                <div
                                                                    style={{
                                                                        paddingLeft: 0,
                                                                        paddingRight: 0,
                                                                        textAlign: 'center'
                                                                    }}>
                                                                    <div className="czas"
                                                                         style={{paddingTop: 8}}>ID: <b>{item.idBi}</b>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                            <div className="col-sm-10 centerMobilka">
                                                                <div className="row">
                                                                    <div className="col-sm-1 displayNoneMobilka"
                                                                         style={{
                                                                             textAlign: 'right',
                                                                             paddingLeft: 0,
                                                                             paddingRight: 0,
                                                                             maxWidth: 30
                                                                         }}>
                                                                        <div className="godzinaOdjazd"><i
                                                                            className="fa fa-arrow-right"
                                                                            style={{
                                                                                fontSize: '1.25rem',
                                                                                paddingTop: 0
                                                                            }}> </i>
                                                                        </div>
                                                                        <div className="godzinaPrzyjazd"><i
                                                                            className="fa fa-arrow-left"
                                                                            style={{
                                                                                fontSize: '1.25rem',
                                                                                paddingTop: 0
                                                                            }}> </i>
                                                                        </div>
                                                                    </div>
                                                                    <div
                                                                        className="col-sm-5 text-left miejscaJednorazoweMobilka"
                                                                        style={{paddingLeft: 15, paddingRight: 5}}>
                                                                        <div className="miejsceOdjazd">{item.nazMiOd}
                                                                            <span> {item.nazPrOd !== null ? item.nazPrOd.substr(0, 25) : item.nazPrOd}</span>
                                                                        </div>
                                                                        <div className="miejscePrzyjazd">{item.nazMiDo}
                                                                            <span> {item.nazPrDo !== null ? item.nazPrDo.substr(0, 25) : item.nazPrDo}</span>
                                                                        </div>
                                                                    </div>
                                                                    <div className="col-sm-4 miejscaJednorazoweMobilka"
                                                                         style={{textAlign: 'left'}}>
                                                                        <div
                                                                            className="czas"
                                                                            style={{paddingTop: 3}}>
                                                                            <b>{this.checkWazny(item)}</b>
                                                                        </div>
                                                                        <div
                                                                            className="czas"
                                                                            style={{paddingTop: 0}}><i
                                                                            className="fa fa-user"> </i>
                                                                            <b>{item.klient}</b></div>
                                                                    </div>
                                                                    <div className="col-sm-2 typCenaMobilka"
                                                                         style={{
                                                                             paddingLeft: 0,
                                                                             paddingRight: 0,
                                                                             textAlign: 'left'
                                                                         }}>
                                                                        <div className="czas"
                                                                             style={{paddingTop: 8}}>Typ: <b>{item.nazZniz}</b>
                                                                        </div>
                                                                        <div
                                                                            className="cenaNormalny"
                                                                            style={{paddingTop: 8}}>Cena: <span>{acc.formatMoney(item.cena, {
                                                                            symbol: "zł",
                                                                            format: "%v %s"
                                                                        })}</span></div>
                                                                    </div>

                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-6">&nbsp;</div>
                                                                    <div className="col-6 miejscaJednorazoweMobilka text-left" style={{paddingLeft: '0px'}}>
                                                                        {item.nipParagon !== null && item.nipParagon !== '' ?
                                                                            <div
                                                                                className="czas"
                                                                                style={{paddingTop: 0, marginLeft: "-8px"}}><i
                                                                                className="fa fa-briefcase"/><b>{item.nipParagon}</b>
                                                                            </div> : null}
                                                                    </div>
                                                                </div>
                                                                <div className="row"
                                                                     style={{paddingRight: 25, paddingTop: 5}}>
                                                                    <div className="col-sm-2">
                                                                        <div className="czas" style={{
                                                                            fontSize: '0.75rem',
                                                                            textAlign: 'left'
                                                                        }}>{this.checkStatus(item.statPoz)}</div>
                                                                    </div>
                                                                    <div className="col-sm-2 text-right"
                                                                         style={{paddingRight: 0}}>
                                                                        <Link
                                                                            to={item.czyOcena ? '/konto/bilety/jednorazowe/zglos/' + item.idBi + '/' + item.idKu + '/ocena' : item.statPoz !== 2 || item.statPoz === -2 ? '/konto/bilety/jednorazowe' : '/konto/bilety/jednorazowe/zglos/' + item.idBi}><Button
                                                                            bsSize="small"
                                                                            disabled={item.statPoz !== 2 || item.statPoz === -2}
                                                                            style={item.statPoz !== 2 || item.statPoz === -2 ? {
                                                                                color: 'graytext',
                                                                                opacity: '0.65',
                                                                                background: 'buttonface'
                                                                            } : {
                                                                                color: 'white',
                                                                                background: '#ffa707'
                                                                            }}>
                                                                            <i className="fa fa-star"
                                                                               style={{
                                                                                   color: 'white',
                                                                                   paddingTop: 2,
                                                                                   paddingBottom: 2,
                                                                                   paddingLeft: 2,
                                                                                   paddingRight: 2
                                                                               }}
                                                                               aria-hidden="true"> </i>{!item.czyOcena ? 'Oceń' : 'Ocena'}
                                                                        </Button></Link>
                                                                    </div>
                                                                    <div className="col-sm-2">
                                                                        {item.statPoz < 0 ?
                                                                            <Button
                                                                                bsStyle={"disabled"} bsSize="small"
                                                                                disabled={true}
                                                                                onClick={() => console.log('pobieram')}><i
                                                                                className="fa fa-download"
                                                                                style={{
                                                                                    color: 'white',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    paddingLeft: 2,
                                                                                    paddingRight: 2
                                                                                }}
                                                                                aria-hidden="true"> </i>Pobierz</Button> :
                                                                            <a href={AppConfig.HOST_API() + 'client/api/bilety/getpdf/' + item.idBi + '/' + item.platnosciTransakcja + AppConfig.V_LOG()}><Button
                                                                                bsStyle={"success"} bsSize="small"
                                                                                onClick={() => console.log('pobieram')}><i
                                                                                className="fa fa-download"
                                                                                style={{
                                                                                    color: 'white',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    paddingLeft: 2,
                                                                                    paddingRight: 2
                                                                                }}
                                                                                aria-hidden="true"> </i>Pobierz</Button></a>
                                                                        }
                                                                    </div>
                                                                    <div className="col-sm-2">
                                                                        {item.statPoz < 0 ?
                                                                            <Button
                                                                                bsStyle={"disabled"} disabled={true}
                                                                                bsSize="small"><i
                                                                                className="fa fa-print"
                                                                                style={{
                                                                                    color: 'white',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    paddingLeft: 2,
                                                                                    paddingRight: 2
                                                                                }}
                                                                                aria-hidden="true"> </i>Drukuj</Button> :
                                                                            <a target="_blank"
                                                                               href={AppConfig.HOST_API() + 'client/api/bilety/getpdf/' + item.idBi + '/' + item.platnosciTransakcja + '?download=false' + AppConfig.V_LOG_SECOND_PARAM()}><Button
                                                                                bsStyle={"info"} bsSize="small"><i
                                                                                className="fa fa-print"
                                                                                style={{
                                                                                    color: 'white',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    paddingLeft: 2,
                                                                                    paddingRight: 2
                                                                                }}
                                                                                aria-hidden="true"> </i>Drukuj</Button></a>
                                                                        }
                                                                    </div>
                                                                    <div className="col-sm-2 text-left">
                                                                        <ReactTooltip
                                                                            id={(item.idKu + 1234567).toString()}>
                                                                            <div className="text-left">
                                                                                Faktura dostępna dla biletu o statusie
                                                                                OPŁACONY lub SKASOWANY z wprowadzonym
                                                                                NIP
                                                                            </div>
                                                                        </ReactTooltip>
                                                                        {item.statPoz !== 1 && item.statPoz !== 2 ?
                                                                            <div data-tip
                                                                                 data-for={(item.idKu + 1234567).toString()}
                                                                                 data-place="bottom"><Button
                                                                                bsStyle={"disabled"} disabled={true}
                                                                                bsSize="small"><i
                                                                                className="fa fa-file-text-o"
                                                                                style={{
                                                                                    color: 'white',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    paddingLeft: 2,
                                                                                    paddingRight: 2
                                                                                }}
                                                                                aria-hidden="true"> </i>Faktura</Button>
                                                                            </div> :
                                                                            <div>{item.nipParagon !== null && item.nipParagon !== "" ?
                                                                                <Link
                                                                                    to={'/faktura/' + item.idBi}><Button
                                                                                    bsStyle={"success"}
                                                                                    bsSize="small"><i
                                                                                    className="fa fa-file-text-o"
                                                                                    style={{
                                                                                        color: 'white',
                                                                                        paddingTop: 2,
                                                                                        paddingBottom: 2,
                                                                                        paddingLeft: 2,
                                                                                        paddingRight: 2
                                                                                    }}
                                                                                    aria-hidden="true"> </i>Faktura</Button></Link> :
                                                                                <div data-tip
                                                                                     data-for={(item.idKu + 1234567).toString()}
                                                                                     data-place="bottom"><Button
                                                                                    bsStyle={"disabled"} disabled={true}
                                                                                    bsSize="small"><i
                                                                                    className="fa fa-file-text-o"
                                                                                    style={{
                                                                                        color: 'white',
                                                                                        paddingTop: 2,
                                                                                        paddingBottom: 2,
                                                                                        paddingLeft: 2,
                                                                                        paddingRight: 2
                                                                                    }}
                                                                                    aria-hidden="true"> </i>Faktura</Button>
                                                                                </div>}</div>
                                                                        }
                                                                    </div>
                                                                    <div className="col-sm-2">
                                                                        <ReactTooltip
                                                                            id={(item.idKu + 123456).toString()}>
                                                                            <div className="text-left">
                                                                                Aby anulować pozycję należy anulować
                                                                                cały
                                                                                bilet
                                                                                o ID: {item.idBi}
                                                                            </div>
                                                                        </ReactTooltip>
                                                                        {(item.statPoz !== 0 && item.statPoz !== 1) || moment().isAfter(item.waznyOd + ' ' + moment(item.godz, 'HH.mm').format('HH:mm')) === true ?
                                                                            <Button bsStyle="disabled" disabled={true}
                                                                                    bsSize="small"
                                                                                    onClick={() => this.submit(item)}><i
                                                                                className="fa fa-times"
                                                                                style={{
                                                                                    color: 'white',
                                                                                    paddingTop: 2,
                                                                                    paddingBottom: 2,
                                                                                    paddingLeft: 2,
                                                                                    paddingRight: 2
                                                                                }}
                                                                                aria-hidden="true"> </i>Anuluj</Button> :
                                                                            <div>
                                                                                {index > 0 && this.state.data[index - 1].idBi === item.idBi ?
                                                                                    <div data-tip
                                                                                         data-for={(item.idKu + 123456).toString()}
                                                                                         data-place="bottom"><Button
                                                                                        bsStyle={"disabled"}
                                                                                        disabled={true} bsSize="small"
                                                                                        onClick={() => this.submit(item)}><i
                                                                                        className="fa fa-times"
                                                                                        style={{
                                                                                            color: 'white',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            paddingLeft: 2,
                                                                                            paddingRight: 2
                                                                                        }}
                                                                                        aria-hidden="true"> </i>Anuluj</Button>
                                                                                    </div> :
                                                                                    <Button bsStyle="danger"
                                                                                            bsSize="small"
                                                                                            onClick={() => this.submit(item)}><i
                                                                                        className="fa fa-times"
                                                                                        style={{
                                                                                            color: 'white',
                                                                                            paddingTop: 2,
                                                                                            paddingBottom: 2,
                                                                                            paddingLeft: 2,
                                                                                            paddingRight: 2
                                                                                        }}
                                                                                        aria-hidden="true"> </i>Anuluj</Button>
                                                                                }</div>}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}</div>}
                                <div className={'row'} style={{marginTop: 15}}>
                                    <div className={'col-lg-4'}>
                                        <button className={'btn btn-success'} onClick={() => this.previousPage()}
                                                disabled={this.state.page === 0 || this.state.totalPages + 1 === 0}>Poprzednia
                                            strona
                                        </button>
                                    </div>
                                    <div className={'col-lg-4 text-center'}
                                         style={{lineHeight: '38px', fontSize: '0.875rem'}}>
                                        {this.state.totalPages + 1 !== 0 ?
                                            <span>Strona {this.state.page + 1} z {this.state.totalPages + 1}</span> : null}
                                    </div>
                                    <div className={'col-lg-4 text-right'}>
                                        <button className={'btn btn-success'} onClick={() => this.nextPage()}
                                                disabled={this.state.page === this.state.totalPages || this.state.totalPages + 1 === 0}>Następna
                                            strona
                                        </button>
                                    </div>
                                </div>
                            </div>}

                    </div>
                </Panel>

            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/components/konto/panel/panelComponents/mojeBiletyComponents/BiletyJednorazowe.js